export const iconFontAwesomeHumanitarianTornado = (
	<i className="fa-solid fa-tornado"></i>
);
